/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMarketplaceListingResponse } from '../../models/get-marketplace-listing-response';

export interface MarketplaceServiceGetMarketplaceListing$Params {
  marketplaceListingId: string;
}

export function marketplaceServiceGetMarketplaceListing(http: HttpClient, rootUrl: string, params: MarketplaceServiceGetMarketplaceListing$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMarketplaceListingResponse>> {
  const rb = new RequestBuilder(rootUrl, marketplaceServiceGetMarketplaceListing.PATH, 'get');
  if (params) {
    rb.path('marketplaceListingId', params.marketplaceListingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMarketplaceListingResponse>;
    })
  );
}

marketplaceServiceGetMarketplaceListing.PATH = '/api/v3/gateway/marketplace/listing/{marketplaceListingId}';
